import {CrownFilled} from '@ant-design/icons';
import {Modal, Button, Typography, Space, Flex} from 'antd';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {ReactComponent as YellowUpgradeCrown} from '../../assets/icons/YellowUpgradeCrown.svg';
import {Routes} from '../../constants/Routes';

const {Title} = Typography;

interface FreeTrialFormModelProps {
  open: boolean;
  onCancel: () => void;
}
const crownWrapperStyle = {
  backgroundColor: '#fff',
  borderRadius: '50%',
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

// Reusable crown icon component
const CrownIcon: React.FC<{size?: 'small' | 'large'}> = ({size = 'large'}) => (
  <Flex align="center" justify="center" className="upgradeCrownContainer">
    {size === 'small' ? (
      <div style={crownWrapperStyle}>
        <YellowUpgradeCrown />
      </div>
    ) : (
      <YellowUpgradeCrown />
    )}
  </Flex>
);

const FreeTrialFormModel: React.FC<FreeTrialFormModelProps> = ({
  open,
  onCancel
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      title={null}
      footer={null}
      onCancel={onCancel}
      closeIcon={null}
      centered
      width={580}
      bodyStyle={{padding: '25px 15px'}}
      zIndex={10000}
    >
      <Space
        direction="vertical"
        align="center"
        size={28}
        style={{width: '100%'}}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 50,
            height: 50,
            border: '1px solid #faad14',
            borderRadius: '50%'
          }}
        >
          <CrownIcon size="large" />
        </div>

        {/* Title */}
        <Title level={3} style={{margin: 0, color: '#1a3e3d', fontWeight: 600}}>
          Free Trial Expired
        </Title>

        <Flex vertical>
          <div
            style={{
              fontWeight: 600,
              fontSize: 20,
              color: '#0D1C14',
              textAlign: 'center'
            }}
          >
            Your <b>90-day free trial has expired.</b>
          </div>
          <div
            style={{
              color: '#4B5563',
              fontSize: 14,
              paddingTop: 8,
              textAlign: 'center'
            }}
          >
            To continue using all platform features including data entry, report
            downloads, and analytics, please upgrade your plan.
          </div>
          <div
            style={{
              color: '#4B5563',
              fontSize: 14,
              paddingTop: 8,
              textAlign: 'center'
            }}
          >
            Upgrade now to regain full access to the platform.
          </div>
        </Flex>

        {/* Action Buttons */}
        <Space size={16}>
          <Button
            type="primary"
            icon={<CrownFilled />}
            style={{
              background: 'linear-gradient(90deg, #FFD700, #FFB800)',
              border: 'none',
              color: '#3a3333ff',
              boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
              minHeight: '40px'
            }}
            onClick={() => {
              navigate(Routes.PRICING_DETAILS);
              onCancel();
            }}
          >
            Upgrade Plan
          </Button>
          <Button type="primary" size="large" onClick={onCancel}>
            Close
          </Button>
        </Space>
      </Space>
    </Modal>
  );
};

export default FreeTrialFormModel;
